// extracted by mini-css-extract-plugin
module.exports = {"panel":"tab-panel-module--panel--3S20e"};